import React from "react";
import PropTypes from "prop-types";
import chevronDownLarge from "icons/chevron-down-large.svg";

const DisclosureChevron = ({enableHover = false, expanded, onClick, style = {} }) => {
  const expandedStyle = expanded ? { transform: `scaleY(-1)` } : {};
  const hoverStyle = enableHover ? { width: 20, height: 20 } : {};
  const mergedStyle = { ...style, ...expandedStyle };

  return (
    <div
      data-testid="disclosure-chevron"
      style={{...styles.container, ...hoverStyle}}
      onClick={onClick}
      onMouseEnter={(e) => {
        if (enableHover)
          e.currentTarget.style.backgroundColor = "var(--link-water)";
      }}
      onMouseLeave={(e) => {
        if (enableHover)
          e.currentTarget.style.backgroundColor = "transparent";
      }}
      >
      <img
        src={chevronDownLarge}
        style={{...mergedStyle, userSelect: "none"}}
        onClick={onClick}
      />
    </div>
  );
};

DisclosureChevron.propTypes = {
  expanded: PropTypes.bool,
  onClick: PropTypes.func,
  enableHover: PropTypes.bool,
  style: PropTypes.object,
};

const styles = {
  container : {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
  }
}

export default DisclosureChevron;
